module.exports = __webpack_public_path__ + "static/media/crack_map_exec_logo.e6c66877.svg";